export enum AgentType {
  Driver = "Driver",
  ServiceAgent = "ServiceAgent",
  Manager = "Manager",
  Robot = "Robot"
}
